import React from 'react';
import PropTypes from 'prop-types';
import NewsFeedTypeFilter, { TYPE_FILTERS_NAME } from './news-feed-type-filter';
import NewsFeedTagFilter, { TAG_FILTERS_NAME } from './news-feed-tag-filter';

class NewsFeedHeader extends React.Component {
    getConfigByName(name) {
        const { options } = this.props;
        return options.filters.find((filter) => filter.name === name);
    }

    onFiltersChange = (filterName, changedCheckboxValue, isChecked) => {
        const selectedFilters = this.props.filters[filterName];
        let newValue = null;

        if (isChecked) {
            newValue = [...selectedFilters, changedCheckboxValue];
        } else {
            newValue = selectedFilters.filter((value) => value !== changedCheckboxValue);
        }

        this.props.onFiltersChange({ [filterName]: newValue });
    }

    render() {
        return (
            <div className="news-feed-header">
                <h2 className="news-feed-header__title">
                    <span>{this.props.translations.title} </span>
                    <b className="news-feed-header__short-date">{this.props.translations.shortDate}</b>
                    <b className="news-feed-header__date">{this.props.translations.date}</b>
                </h2>
                <div className="news-feed-header__tag-filter">
                    <NewsFeedTagFilter
                        config={this.getConfigByName(TAG_FILTERS_NAME)}
                        selectedFilters={this.props.filters[TAG_FILTERS_NAME]}
                        onFiltersChange={this.onFiltersChange}
                    />
                </div>
                <div className="news-feed-header__type-filter">
                    <NewsFeedTypeFilter
                        config={this.getConfigByName(TYPE_FILTERS_NAME)}
                        selectedFilters={this.props.filters[TYPE_FILTERS_NAME]}
                        onFiltersChange={this.onFiltersChange}
                    />
                </div>
            </div>
        );
    }
}

NewsFeedHeader.propTypes = {
    filters: PropTypes.object.isRequired,
    options: PropTypes.object.isRequired,
    translations: PropTypes.object,
    onFiltersChange: PropTypes.func.isRequired
};

export default NewsFeedHeader;
